<template>
  <div uk-grid>
    <div class="uk-width-1-2@s uk-margin-auto">
      <div class="uk-section uk-padding-small">
        <form>
          <div class="uk-margin">
            <label class="uk-form-label" for="form-stacked-text"
              >タイトル</label
            >
            <div class="uk-form-controls">
              <input
                class="uk-input"
                id="form-stacked-text"
                type="text"
                placeholder="Some text..."
                v-model="item.title"
              />
            </div>
          </div>
          <div class="uk-margin uk-grid-small uk-child-width-auto uk-grid">
            <label class=""
              ><input
                class="uk-radio"
                type="radio"
                v-model="item.level"
                name="radio2"
                value="初級"
              />
              初級</label
            >
            <label class=""
              ><input
                class="uk-radio"
                type="radio"
                v-model="item.level"
                name="radio2"
                value="中級"
              />
              中級</label
            >
            <label class=""
              ><input
                class="uk-radio"
                type="radio"
                v-model="item.level"
                name="radio2"
                value="上級"
              />
              上級
            </label>
          </div>
          <div class="uk-margin uk-grid-small uk-child-width-auto uk-grid">
            <label class=""
              ><input
                class="uk-radio"
                type="radio"
                v-model="item.genre"
                name="radio1"
                value="フォアハンド"
              />
              フォアハンド</label
            >
            <label class=""
              ><input
                class="uk-radio"
                type="radio"
                v-model="item.genre"
                name="radio1"
                value="バックハンド"
              />
              バックハンド</label
            >
            <label class=""
              ><input
                class="uk-radio"
                type="radio"
                v-model="item.genre"
                name="radio1"
                value="試合"
              />
              試合</label
            >
            <label class=""
              ><input
                class="uk-radio"
                type="radio"
                v-model="item.genre"
                name="radio1"
                value="フットワーク"
              />
              フットワーク</label
            >
            <label class=""
              ><input
                class="uk-radio"
                type="radio"
                v-model="item.genre"
                name="radio1"
                value="多球練習"
              />
              多球練習</label
            >
            <label class=""
              ><input
                class="uk-radio"
                type="radio"
                v-model="item.genre"
                name="radio1"
                value="サーブ"
              />
              サーブ</label
            >
            <label class=""
              ><input
                class="uk-radio"
                type="radio"
                v-model="item.genre"
                name="radio1"
                value="レシーブ・台上"
              />
              レシーブ・台上</label
            >
            <label class=""
              ><input
                class="uk-radio"
                type="radio"
                v-model="item.genre"
                name="radio1"
                value="その他"
              />
              その他</label
            >
          </div>
          <div class="uk-margin">
            <label class="uk-form-label" for="form-stacked-text"
              >練習方法詳細</label
            >
            <div class="uk-form-controls">
              <textarea
                id="form-stacked-text"
                class="uk-textarea"
                rows="5"
                placeholder="Textarea"
                v-model="item.how_to_training.text"
              ></textarea>
            </div>
          </div>
          <div class="uk-margin">
            <label class="uk-form-label" for="form-stacked-text"
              >練習方法画像URL</label
            >
            <div class="uk-form-controls">
              <input
                class="uk-input"
                id="form-stacked-text"
                type="text"
                placeholder="Some text..."
                v-model="item.how_to_training.img"
              />
              <img v-bind:src="item.how_to_training.img" alt="" class="single_img" />
            </div>
          </div>
          <div class="uk-margin">
            <label class="uk-form-label" for="form-stacked-text"
              >参考詳細</label
            >
            <div class="uk-form-controls">
              <textarea
                id="form-stacked-text"
                class="uk-textarea"
                rows="5"
                placeholder="Textarea"
                v-model="item.references.text"
              ></textarea>
            </div>
          </div>
          <div class="uk-margin">
            <label class="uk-form-label" for="form-stacked-text"
              >参考動画URL</label
            >
            <div class="uk-form-controls">
              <input
                class="uk-input"
                id="form-stacked-text"
                type="text"
                placeholder="Some text..."
                v-model="item.references.img"
              />
            </div>
          </div>
          <div class="uk-margin">
            <label class="uk-form-label" for="form-stacked-text">コツ</label>
            <div class="uk-form-controls">
              <textarea
                id="form-stacked-text"
                class="uk-textarea"
                rows="5"
                placeholder="Textarea"
                v-model="item.other"
              ></textarea>
            </div>
          </div>
          <button
            class="uk-button uk-button-default uk-display-block uk-margin-auto"
            @click="submit"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  created() {
    if (!this.$route.params.item_id) return

    const item = this.$store.getters.getItemById(this.$route.params.item_id)
    if (item) {
      this.item = item
    } else {
      this.$router.push({ name: 'AdminHome' })
    }
  },
  data() {
    return {
      item: {
        references: {},
        how_to_training: {},
      },
    }
  },
  methods: {
    submit() {
      if (this.$route.params.item_id) {
        this.updateItem({
          id: this.$route.params.item_id,
          item: this.item,
        })
      } else {
        this.addItems(this.item)
      }
      this.$router.push({ name: 'AdminHome' })
      this.item = {}
    },
    ...mapActions(['addItems', 'updateItem']),
  },
}
</script>

<style>
</style>